import { useDisplay } from 'vuetify'

export function useResponsive () {
  const { smAndDown } = useDisplay()

  return {
    isMobile: smAndDown,
  }
}
